declare const bootstrap: any
interface CustomisedService {
    FormInit?: () => Promise<void>;
    show?: (data?: Record<string, string>) => Promise<void>;
    shown?: () => void;
    success?: (data?: Record<string, string>) => Promise<void>;
    submit?: (data?: any) => boolean | void;
}
const HcpDetails = {
    PrescriberFirstName: "",
    PrescriberLastName: "",
    PrescriberEmail: "",
    PrescriberLocation: "",
    PrescriberAddress: "",
    PrescriberState: "",
    PrescriberPostcode: "",
    PrescriberPhoneNumber: "",
    PrescriberSpeciality: "",
    PrescriberJobType: ""
}

const therapyDetails = {
    Therapy: "",
    PrescriberSpeciality: "",
    PrescriberJobType: ""
};


//service customisations (PER SERVICE)
export const CustomServiceLogic: Record<string, CustomisedService> = {
    NewReferral: {
        async FormInit() {
            const radios = document.querySelectorAll<HTMLInputElement>(
                'input[type="radio"][name="Therapy"]'
              );
              
                radios.forEach((radio) => {
                    radio.addEventListener('change', () => {
                      if (radio.checked && radio.value === '-') {
                        const modalElement = document.getElementById('not-found-product');
                        const modal = new bootstrap.Modal(modalElement);
                        modal.show();
                        // close btn click should close not-found-product popup
                        document.querySelectorAll<HTMLButtonElement>("#not-found-product button.close")[0].addEventListener("click", () => {
                            (document.getElementsByName("NewReferral")[0] as HTMLFormElement)?.reset();
                        });
                      }
                  
                    });
                  });
        },
        async show() { },
        submit(data: any) {
            Object.assign(therapyDetails, data);
            CustomTreatmentSelectHandler(data);
        },
        async success(data: any) { }
    },
    PatientReferral_Avtozma: {
        async FormInit() {
            populateForm();
            document.querySelectorAll<HTMLButtonElement>("#not-found-product button.close")[0].addEventListener("click", () => {
                (document.getElementsByName("NewReferral")[0] as HTMLFormElement)?.reset();
            });
        },
        async show() {
            cp.api.switchProgram("cell-avtozma");
        },
        submit(data?: any) {
            data.TreatmentName = "Avtozma";
            const ahpra = localStorage.getItem("AHPRA");
            if (ahpra)
                data.AHPRANumber = ahpra;
        },
        async success(data?: Record<string, string>) {
            storeHcpData(data!);
            Object.assign(therapyDetails, {});
        }
    },
    PatientReferral_Omlyclo: {
        async FormInit() {
            populateForm();
        },
        async show() {
            cp.api.switchProgram("cell-omlyclo");
        },
        submit(data?: any) {
            data.TreatmentName = "Omlyclo";
            const ahpra = localStorage.getItem("AHPRA");
            if (ahpra)
                data.AHPRANumber = ahpra;
        },
        async success(data?: Record<string, string>) {
            storeHcpData(data!);
            Object.assign(therapyDetails, {});
        }
    },
    PatientReferral_Stoboclo: {
        async FormInit() {
            populateForm();
        },
        async show() {
            cp.api.switchProgram("cell-stoboclo");
        },
        submit(data?: any) {
            data.TreatmentName = "Stoboclo";
            const ahpra = localStorage.getItem("AHPRA");
            if (ahpra)
                data.AHPRANumber = ahpra;
        },
        async success(data?: Record<string, string>) {
            storeHcpData(data!);
            Object.assign(therapyDetails, {});
        }
    },
    ReferralCompletion_Avtozma: {
        async success(data?: Record<string, string>) {
            hideAllModalButtons()
            setTimeout(() => {
                cp.ui.navigate("/en/patient");
              }, 5000);
            }
    },
    ReferralCompletion_Omlyclo: {
        async success(data?: Record<string, string>) {
            hideAllModalButtons()
            cp.api.switchProgram("cell-omlyclo");
            setTimeout(() => {
                cp.ui.navigate("/en/patient");
              }, 5000);
        }
    },
    ReferralCompletion_Stoboclo: {
        async success(data?: Record<string, string>) {
            hideAllModalButtons()
            setTimeout(() => {
                cp.ui.navigate("/en/patient");
              }, 5000);
        }
    }
};

function CustomTreatmentSelectHandler(data: Record<string, string>) {
    const therapy = data.Therapy;
    //call the correct enrol form & pass along / init the data
    const enrolForm = cp.services.list["patientreferral_" + therapy.toLowerCase()];
    if (!enrolForm) {
        alert("Wrong form, retry again");
    } else {
        cp.ui.closeAllModals();
        enrolForm.show();
    }
    return false;//do not proceed with treatment select form
}

function getHcpData(): Record<string, object> {
    const hcpData = localStorage.getItem("HCPDATA");
    if (hcpData) {
        try {
            return JSON.parse(hcpData);
        } catch (e) {
            console.error("Error parsing localStorage data, resetting database.", e);
            return {};
        }
    }
    return {};
}

function populateForm(): void {
    // prefill hcp details based on localStorage data
    const hcpData: Record<string, object> = getHcpData();
    const ahpra = localStorage.getItem("AHPRA");
    if (!ahpra) {
        cp.ui.navigate("/en");
        return;
    } else {
        const hcpDetails = (hcpData != undefined) ? hcpData[ahpra] : undefined;
        // fill up form with details of localStorage
        if (hcpDetails && Object.keys(hcpDetails).length) {
            Object.keys(HcpDetails).forEach((key) => {
                const element = document.getElementsByName(key)[0] as HTMLInputElement | HTMLSelectElement;
                if (element) {
                    element.value = (hcpDetails as Record<string, string>)[key] || "";
                }
            });
        }
    }

    // if new HCP then prefill therapy details from popup selected fields
    // prefill therapy details in hidden fields
    const prescriberJobType = (document.getElementsByName("PrescriberJobType")[0] as HTMLSelectElement);
    prescriberJobType.value = therapyDetails.PrescriberJobType;
    if (therapyDetails.PrescriberSpeciality) {
        const prescriberSpeciality = (document.getElementsByName("PrescriberSpeciality")[0] as HTMLSelectElement);
        prescriberSpeciality.value = therapyDetails.PrescriberSpeciality;
    }

    // hide delivery details if PrescriberJobType = "Pharmacist"
    if (therapyDetails.PrescriberJobType == "Pharmacist") {
        const deliveryInput = document.querySelector('input[name="RequireDelivery"]');

        if (deliveryInput) {
            const currentFormRow = deliveryInput.closest('.form-row');
            if (currentFormRow) {
                currentFormRow.classList.add('d-none');

                const aboveFormRow = currentFormRow.previousElementSibling;

                if (aboveFormRow && aboveFormRow.classList.contains('form-row')) {
                    aboveFormRow.classList.add('d-none');
                }
            }
        }
    }
}


function storeHcpData(data: any): void {
    const ahpraNumber = localStorage.getItem("AHPRA");
    if (!ahpraNumber) {
        console.log("No Ahpra number there");
    } else {
        const details: Record<string, string> = {};
        Object.keys(HcpDetails).forEach((key) => {
            details[key] = data[key];
        });
        const hcpDataset: Record<string, object> = getHcpData();

        hcpDataset[ahpraNumber] = details;

        localStorage.setItem('HCPDATA', JSON.stringify(hcpDataset));
    }
}

function hideAllModalButtons(): void {
    const modal = document.querySelector('.axsvc-success');

if (modal) {
  const buttons = modal.querySelectorAll<HTMLButtonElement | HTMLInputElement>(
    'button, input[type="button"]'
  );

  buttons.forEach((button) => {
    button.style.display = 'none';
  });
}
}

["show", "shown", "submit", "success"].forEach((e: any) => {
    cp.event.subscribe("service:" + e, (serviceName: any, d: any) => {
        //if we have customisations for this service then run them
        //if (CustomServiceLogic[serviceName]?.[e]) CustomServiceLogic[key][e]();
        Object.keys(CustomServiceLogic).forEach((key) => {
            if (key.toLowerCase() == serviceName.toLowerCase() && CustomServiceLogic[key][e]) {
                CustomServiceLogic[key][e](d);
            }
        });
    });


});

cp.event.subscribe("form:load", (serviceName: any, data: any) => {
    Object.keys(CustomServiceLogic).forEach((key) => {
        if (key.toLowerCase() == serviceName && CustomServiceLogic[key].FormInit) {
            CustomServiceLogic[key].FormInit?.();
        }
    });
});

cp.event.subscribe("app:ready", (serviceName: any, data: string) => {
    if (PageCustomisations[data]) PageCustomisations[data]();
});


const PageCustomisations: Record<string, () => Promise<void>> = {
    //customisations per page type
    StartPage: async () => {
        document.querySelector('button[data-action="enter"]')?.addEventListener("click", validateAhpraNumber);
    }
}

async function validateAhpraNumber() {
    const ahpraNumber = (document.getElementsByName("ahpra")[0] as HTMLInputElement).value;
    await fetch("/app/validateAHPRA?ahpraNumber=" + ahpraNumber).then(async function (r) {
        var result = await r.text();
        if (result && result.replace(/\"/g, "") == "Valid") {
            window.localStorage.setItem("AHPRA", ahpraNumber);
            cp.ui.navigate("/en/hcp");
        }
        else {
            const modalElement = document.getElementById("invalid-aphra-code");
            if (modalElement) {
                const modal = new (window as any).bootstrap.Modal(modalElement);
                modal.show();
            }
        }
    });
}
